import * as React from "react";
import type { SVGProps } from "react";
const SvgPause = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#pause_svg__a)">
      <path d="M9 20H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2M7 6v12h2V6zM17 20h-2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2M15 6v12h2V6z" />
    </g>
    <defs>
      <clipPath id="pause_svg__a">
        <path fill="#fff" d="M5 4h14v16H5z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPause;
